






























































































































import { Component } from "vue-property-decorator";
import { BaseOperationPropertyVue } from "fs-pb-vue2/vueModels/operations/properies/BaseOperationPropertyVue";
import { ContractsStore } from "fs-pb-vue2/store/modules/contracts";
import { getModule } from "vuex-module-decorators";
import { ContractModel } from "fs-pb-vue2/models/contracts/contractModel";

@Component({})
export default class ListProperty extends BaseOperationPropertyVue {

  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  getContract(refId: string): ContractModel {
    return this.contractsStore.contracts.getContractByRefId(refId);
  }

  getContractSum(c: ContractModel): string {
    return `${c.Data.ContractType === 5 ? c.Rest : c.DisposableLimit} ${c.Currency}`;
  }

  get caption(): string {
    return this.property.Declaration.Default != '' && this.property.Declaration.Type == 0 ? this.property.Declaration.Description : this.property.Declaration.Caption;
  }

  get readonly(): boolean {
    const finalContractTo = Boolean(this.$route.query.finalContractTo);
    const finalContract = Boolean(this.$route.query.finalContract);

    return (
      this.property.Declaration.View == 1 || this.disable || 
      ((this.property.Declaration.Name.toLowerCase() === "contractto" && finalContractTo) ||
      (this.property.Declaration.Name.toLowerCase() === "contract" && finalContract))
    );
  }
}
